import { render, staticRenderFns } from "./StyledCheckbox.vue?vue&type=template&id=1261d5e1&scoped=true&"
import script from "./StyledCheckbox.vue?vue&type=script&lang=js&"
export * from "./StyledCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./StyledCheckbox.vue?vue&type=style&index=0&id=1261d5e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261d5e1",
  null
  
)

export default component.exports